export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) return

  const shareId = useState('shareId')
  const authUser = useState('authUser')
  const o3AccessToken = useCookie('o3AccessToken')
  const o3RefreshToken = useCookie('o3RefreshToken')

  if(!authUser.value) {
    if(o3AccessToken.value && o3RefreshToken.value) {
      const accessToken = useState('accessToken')
      const refreshToken = useState('refreshToken')
      accessToken.value = o3AccessToken.value
      refreshToken.value = o3RefreshToken.value
      await updateUserInfo()
    }
  }

  if(!authUser.value) {
    const redirect = encodeURIComponent(to.fullPath)

    let navigateUrl = '/login'

    // @ts-ignore
    if(shareId.value && shareId.value !== '' && shareId.value !== 'undefined' && shareId.value?.trim() !== '') {
      navigateUrl = `/login?shareId=${shareId.value}`
    }

    return navigateTo(navigateUrl, {
      external: true
    })
  }
})
